import { createSlice } from '@reduxjs/toolkit';

import { Portfolio } from '@mfe/shared/schema-types';

import { ErrorsObj, RuntimeError } from '../graphql';

type PortfolioState = {
  loading: boolean;
  portfolio: Portfolio | null;
  error: ErrorsObj | RuntimeError | null;
};

export const initialPortfolioState: PortfolioState = {
  loading: false,
  portfolio: null,
  error: null,
};

export const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState: initialPortfolioState,
  reducers: {
    getPortfolio: (state) => {
      state.loading = true;
    },
    setPortfolio: (state, { payload }) => {
      state.loading = false;
      state.portfolio = payload;
    },
    setPortfolioError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export const { getPortfolio, setPortfolio, setPortfolioError } =
  portfolioSlice.actions;

export const selectPortfolio = (state: { portfolio: PortfolioState }) =>
  state.portfolio;
